/*
 * Homepage scroll effects (the "calm desert" trial; see ruck-custom.css).
 *
 *  - Headlines and their copy rise, sharpen and fade in, slowly, in sequence.
 *  - Each framed section opens from its center line outward.
 *  - The hero copy lifts a little as you scroll off it (the photo stays put).
 *
 * Everything keys off the page scroller, .page-wrapper (html and body are
 * overflow: hidden in this theme). Nothing is hidden until this script adds
 * .fx-ready to <html>, so a failure leaves the page fully visible. Skipped
 * entirely under prefers-reduced-motion and in the theme editor.
 */
(function () {
  'use strict';

  if (!document.querySelector('.ruck-home-hero')) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var scroller = document.querySelector('.page-wrapper');
  var main = document.getElementById('MainContent');
  if (!scroller || !main) return;

  var DARK = '[id$="__custom_liquid_69GiMz"], [id$="__waitlist_form_homeDemo"]';

  function clamp01(v) {
    return Math.min(Math.max(v, 0), 1);
  }

  /* Reveals ------------------------------------------------------------- */

  var revealTargets = [];

  function mark(el, delay) {
    if (!el || el.classList.contains('fx')) return;
    el.classList.add('fx');
    if (delay) el.style.setProperty('--fx-delay', delay + 's');
    revealTargets.push(el);
  }

  var heroTitle = main.querySelector('.ruck-home-hero__title');
  var heroBody = main.querySelector('.ruck-home-hero__body');
  mark(heroTitle, 0);
  mark(heroBody, 0.1);

  [].forEach.call(main.querySelectorAll('.ruck-home-grid:not(.ruck-home-demo) .ruck-reveal > h2'), function (h2) {
    if (h2.closest(DARK)) return;
    mark(h2, 0);
    mark(h2.nextElementSibling && h2.nextElementSibling.tagName === 'P' ? h2.nextElementSibling : null, 0.1);
  });

  var frames = [].slice.call(main.querySelectorAll('.ruck-home-grid:not(.ruck-home-demo)'));
  frames.forEach(function (frame) {
    frame.classList.add('fx-frame');
  });

  // A clipped-away frame reports as not intersecting, so each frame is watched
  // through its section wrapper, which is never clipped.
  var frameOf = new Map();
  frames.forEach(function (frame) {
    frameOf.set(frame.closest('.shopify-section') || frame.parentElement, frame);
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = frameOf.get(entry.target) || entry.target;
        io.unobserve(entry.target);
        el.classList.add('fx-in');
        if (el.classList.contains('fx-frame')) {
          // Lift the clip once it has opened, so nothing stays cropped.
          window.setTimeout(function () {
            el.classList.add('fx-done');
          }, 1000);
        }
      });
    },
    { root: null, rootMargin: '0px 0px -4% 0px', threshold: 0.02 }
  );

  document.documentElement.classList.add('fx-ready');
  revealTargets.forEach(function (el) {
    io.observe(el);
  });
  frameOf.forEach(function (frame, wrapper) {
    io.observe(wrapper);
  });

  /* Hero drift ----------------------------------------------------------- */

  var hero = main.querySelector('.ruck-home-hero');
  var heroContent = main.querySelector('.ruck-hero-bg__content');

  var pending = false;

  function drift() {
    pending = false;
    var p = clamp01(scroller.scrollTop / (hero.offsetHeight || 1));
    heroContent.style.transform = 'translate3d(0,' + (-p * 56).toFixed(1) + 'px,0)';
  }

  if (hero && heroContent) {
    scroller.addEventListener(
      'scroll',
      function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(drift);
      },
      { passive: true }
    );
  }
})();
